import { render } from "./DetalheCartaProposta.vue?vue&type=template&id=0b857221&scoped=true"
import script from "./DetalheCartaProposta.vue?vue&type=script&lang=js"
export * from "./DetalheCartaProposta.vue?vue&type=script&lang=js"

import "./DetalheCartaProposta.vue?vue&type=style&index=0&id=0b857221&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b857221"]])

export default __exports__